import React from "react";
import { Box, Card, CardContent, Tooltip, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

interface EnergyBalanceCardProps {
  energyBalance?: number;
  targetDailyIntake?: number | null;
  showEmptyState?: boolean;
}

export const EnergyBalanceCard: React.FC<EnergyBalanceCardProps> = ({ energyBalance, targetDailyIntake, showEmptyState = false }) => {
  const isPositive = energyBalance != null && energyBalance >= 0;
  const balanceColor = "#101828";

  return (
    <Card
      sx={{
        height: "100%",
        background: "#f8fafb",
        border: "1px solid #eaecf0",
        borderRadius: 0.75,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1, "&:last-child": { paddingBottom: 2 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, fontSize: 12, lineHeight: "16px" }}>
            Energy Balance
          </Typography>
          <Tooltip title="This is calculated from meal plan targets">
            <InfoIcon sx={{ fontSize: 16, color: "text.secondary", cursor: "help" }} />
          </Tooltip>
        </Box>

        {showEmptyState ? (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4 }}>
            <Typography variant="h3" sx={{ fontSize: 20, lineHeight: "28px" }}>
              —
            </Typography>
          </Box>
        ) : (
          <Typography variant="h3" sx={{ fontSize: 20, lineHeight: "28px", color: balanceColor }}>
            {targetDailyIntake === null || targetDailyIntake === undefined || energyBalance === undefined ? "—" : `${isPositive ? "+" : ""}${Math.round(energyBalance).toLocaleString()} kcal`}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};
